/** similar to array.filter, but will return mismatching results in a separate array.
 * @returns [matches, mismatches]
 * */
export function arraySplitByCondition(array, filter) {
  return array.reduce((result, elem, index) => {
    result[filter(elem, index) ? 0 : 1].push(elem);
    return result;
  }, [[], []]);
}